module.exports = __webpack_public_path__ + "img/Checkmark-blue.a2c34c59.svg";